// flights_unified_price_tag

import { useCallback } from "react";
import useProfiler from "hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";

const utils = createMicroConversionTrackingUtils({
  name: "flights_unified_price_tag",
  stages: {
    main: 1,
    desktop: 2,
    mobile: 3
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {},
  goalsWithValue: []
});

export const useTrackUnifiedPriceTag = () => {
  const { isDesktop, isMobile } = useProfiler();

  const trackUnifiedPriceTag = useCallback(() => {
    return !!utils.trackWithDefaultStage();
  }, []);

  const trackUnifiedPriceTagStages = useCallback(() => {
    utils.stages.main();

    if (isDesktop()) utils.stages.desktop();
    if (isMobile()) utils.stages.mobile();

    return null;
  }, [isDesktop, isMobile]);

  return {
    trackUnifiedPriceTag,
    trackUnifiedPriceTagStages
  };
};
